import React from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarLayout } from '../shared/SidebarLayout';

const NAV = [
  { to:'/admin',          label:'Dashboard',      icon:'📊', end:true },
  { to:'/admin/clients',  label:'Clientes',       icon:'👥' },
  { to:'/admin/template', label:'Plantilla Base', icon:'🏪' },
  { to:'/admin/settings', label:'Configuración',  icon:'⚙️' },
];

export default function AdminLayout() {
  return (
    <SidebarLayout navItems={NAV} title="TiendaSaaS" subtitle="Super Admin">
      <Outlet />
    </SidebarLayout>
  );
}
